import { Component, OnInit,ElementRef } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: false,
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
    constructor(private router: Router, private _elementRef: ElementRef) {
    }
    ngOnInit() {
        //this._elementRef.nativeElement.removeAttribute("ng-version");
    }
}
